<template>
    <v-card>
        <Loader ref="Loader"></Loader>
        <v-layout fill-height row mr-1 ml-1 mt-2>
            <v-flex xs12 sm12 lg12 xl12>
                <v-card>
                    <v-toolbar dense color="secondary" dark>
                        <v-toolbar-title>Roles - Create</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <v-form @submit.prevent="SubmitForm" ref="form" v-model="valid">
                                <v-card-text mt-3 class="elevation-5">
                                    <v-layout>
                                        <v-flex xs5>
                                            <v-text-field autofocus label="Name" v-model="form.Name"
                                                :rules="fieldRules"></v-text-field>
                                        </v-flex>
                                        <v-flex ml-5 v-if="IsMasterRoleLogin() == true">
                                            <v-checkbox v-model="form.Master" color="primary" label="Is master role"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row class="text-xs-right">
                                        <v-flex>
                                            <v-btn color="success" type="submit" :disabled="!valid" @click="SubmitForm">
                                                Save
                                                <v-icon right>mdi-content-save</v-icon>
                                            </v-btn>
                                            <v-btn flat @click="$router.push('/roles/dashboard')">
                                                Cancel</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    import JWT from 'jsonwebtoken'

    export default {
        data() {
            return {
                form: {
                    Name: '',
                    Master: false
                },
                fieldRules: [
                    v => !!v || "Field is required",
                ],
                emailRules: [
                    v => !!v || "E-mail is required",
                    v => /.+@.+/.test(v) || "E-mail must be valid"
                ],
                valid: true,
            };
        },
        methods: {
            SubmitForm() {
                var self = this;
                let Request = JSON.parse(JSON.stringify(self.form));
                Request.AccountID = JWT.decode(localStorage['accessToken']).ACCOUNT_ID;
                self.$refs.Loader.show();
                self.post("Roles", Request)
                    .then(res => {
                        self.$refs.Loader.hide();
                        self.$router.push('/roles/dashboard');
                    })
                    .catch(err => {
                        console.log(err);
                        self.$refs.Loader.hide()
                    });
                this.$refs.form.reset();
            },
            IsMasterRoleLogin() {
                let self = this;
                let sessionData = self.$store.getters.getUserSessionData
                if (sessionData == undefined || sessionData == null || sessionData.Role == undefined || sessionData.Role ==
                    null) {
                    return false;
                } else {
                    return sessionData.Role.Master;
                }
            }
        }
    }
</script>

<style>

</style>